module.exports = __webpack_public_path__ + "static/Silver-level-8ba6d9f4a5a27dff2b45e4df4f113e98.png";